/* c_reco — おすすめと閲覧履歴の共通ロジック。
 *
 * 保存するのは商品ID・ハンドル・タグ・時刻だけ。翻訳済みタイトルと整形済み価格は保存しない。
 * 英語で見た商品が日本語ページに英語のまま出る、市場を切り替えても旧通貨のまま出る、を避けるため。
 * 描画は必ず Section Rendering API でサーバーに任せる。
 */
(function () {
  'use strict';

  // c_reco.liquid と c_reco-track.liquid の両方が同じ script を出すため、
  // 同一ページに両方が乗ったときの二重実行を弾く。
  if (window.__cRecoBooted) return;
  window.__cRecoBooted = true;

  var KEY = 'nokaze_reco_v1';
  var MAX_KEEP = 30;
  var RECENT_LOOKUP = 12;
  var HALF_LIFE_DAYS = 7;
  var WEIGHTS = { artisan: 5, theme: 3, category: 2, origin: 1 };

  /* カートページの「おすすめ」枠（artisan_scope が only 以外）では、カートに入っていない作り手を前に出す。
     初回の注文で作り手を 2 人以上選んだお客様は再購入率 20%、1 人だけだと 6.6%（2026-10-31 リピーター分析）。
     集めた候補に「カートに無い作り手なら +CART_CROSS_ARTISAN_BONUS」を付けて並べ直す（同点は取得順のまま）。
     候補はこれまでどおりテーマ・器種・産地の近さで集めているので、関連の薄い作品が前に来るわけではない。
     カートの作り手の作品は消さずに後ろへ回す（候補が足りないときの埋めに使い、min_items の判定は変えない）。
     「同じ作り手の器」枠（only）と閲覧履歴（recent）はそのまま。見出しの意味が変わるため。 */
  var CART_CROSS_ARTISAN_BONUS = 1;
  /* 並べ直しの余地を作るため、カートページのおすすめ枠では max の何倍まで集めてから絞るか。
     取得は FILL_BUDGET_MS で打ち切られるので、増やしても最悪の待ち時間は変わらない。 */
  var CART_COLLECT_FACTOR = 2;
  var FALLBACK_HANDLES = ['for-gift', 'new-arrivals'];

  // 2本以上のレールが同じ商品を出さないよう、ページ全体で取得済みIDを持ち回る。
  var takenIds = Object.create(null);

  /* ---------- 保存 ---------- */

  function privacyApi() {
    try {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      return api && typeof api.shouldShowBanner === 'function' ? api : null;
    } catch (e) {
      return null;
    }
  }

  /* 閲覧履歴は「この訪問者の好み」の記録なので preferences 区分で判断する
     （analytics ではない）。バナーを出すべき状態＝まだ同意が取られていない
     ので保存しない。API が載らない環境（同意バナー自体を使っていないストア）
     だけ、保存を許す。 */
  function allowedNow() {
    var api = privacyApi();
    // API を待てなかった場合は保存しない（fail-closed）。
    // EU 向けに売る以上、判断できないときに書くほうが筋が悪い。
    if (!api) return consentDecision === 'no-api';
    try {
      if (api.shouldShowBanner()) return false;
      if (typeof api.preferencesProcessingAllowed === 'function') {
        return api.preferencesProcessingAllowed() !== false;
      }
      return api.analyticsProcessingAllowed() !== false;
    } catch (e) {
      // 読み込み途中で throw しうる。判断できないので保存しない
      return false;
    }
  }

  /* Customer Privacy API は非同期で載る。載る前に判断すると意図を満たせないので、
     ロードを試みてから起動する。 */
  /* 'ready'    API が載っている（allowedNow が API に従う）
     'no-api'   loadFeatures 自体が無い＝同意バナーを使っていないストア。保存可
     'timeout'  待ったが載らなかった。保存しない */
  var consentDecision = 'timeout';

  function withConsentApi(next) {
    if (privacyApi()) {
      consentDecision = 'ready';
      next();
      return;
    }

    var hasLoader = false;
    try {
      hasLoader = !!(window.Shopify && typeof window.Shopify.loadFeatures === 'function');
    } catch (e) {
      hasLoader = false;
    }

    if (!hasLoader) {
      consentDecision = 'no-api';
      next();
      return;
    }

    var done = false;
    function go(reason) {
      if (done) return;
      done = true;
      consentDecision = privacyApi() ? 'ready' : reason;
      next();
    }
    try {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function () {
          go('timeout');
        }
      );
      setTimeout(function () {
        go('timeout');
      }, 1500);
    } catch (e) {
      go('timeout');
    }
  }

  /* 読み込みが遅れて後から載った場合に拾う。ここで初めて保存が許される。 */
  document.addEventListener('visitorConsentCollected', function () {
    if (privacyApi()) consentDecision = 'ready';
    // 同意した「そのページ」の1件を拾う。ここで呼ばないと永久に記録されない。
    recordSeed();
  });

  function purge() {
    try {
      window.localStorage.removeItem(KEY);
    } catch (e) {
      /* noop */
    }
  }

  document.addEventListener('visitorConsentCollected', function () {
    if (!allowedNow()) purge();
  });

  /* 保存と同じ判断を読み出しにも掛ける。ePrivacy 5(3) は端末に保存された
     情報への「アクセス」を保存と同等に扱うため。読めなければ候補が空になり、
     min 割れでセクションごと消える（安全側に倒れる）。 */
  function read() {
    if (!allowedNow()) return [];
    try {
      var raw = window.localStorage.getItem(KEY);
      if (!raw) return [];
      var list = JSON.parse(raw);
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX_KEEP)));
    } catch (e) {
      /* 容量超過・プライベートウィンドウ。記録できなくても表示は壊さない */
    }
  }

  function record(item) {
    if (!item || !item.handle || !allowedNow()) return;
    var list = read().filter(function (v) {
      return v.handle !== item.handle;
    });
    list.unshift({
      handle: item.handle,
      tags: (item.tags || []).map(normalizeTag).filter(Boolean),
      at: Date.now()
    });
    write(list);
  }

  /* ---------- 採点 ---------- */

  function decay(at) {
    var t = Number(at);
    // at が欠けた古いレコードで NaN になると、タグ順位が無言で崩れる
    if (!isFinite(t) || t <= 0) return 0;
    var days = (Date.now() - t) / 86400000;
    if (days < 0) days = 0;
    return Math.pow(0.5, days / HALF_LIFE_DAYS);
  }

  function normalizeTag(tag) {
    return String(tag || '').trim().toLowerCase();
  }

  function kindOf(tag) {
    var i = tag.indexOf('-');
    if (i < 0) return null;
    var head = tag.slice(0, i);
    return Object.prototype.hasOwnProperty.call(WEIGHTS, head) ? head : null;
  }

  /* タグ種別ごとに、減衰つきスコアの高い順で返す */
  function rankedTags() {
    var score = Object.create(null);
    read().forEach(function (v) {
      var d = decay(v.at);
      // 0 と「候補なし」を区別する。at 欠落レコードを根拠ゼロの候補にしない
      if (!d) return;
      (v.tags || []).forEach(function (raw) {
        var tag = normalizeTag(raw);
        var kind = kindOf(tag);
        if (!kind) return;
        score[tag] = (score[tag] || 0) + WEIGHTS[kind] * d;
      });
    });
    return groupByKind(score);
  }

  /* タグ種別ごとにまとめ、スコアの高い順に並べる。
     閲覧履歴（rankedTags）とカートの中身（cartRankedTags）で共通。 */
  function groupByKind(score) {
    var by = Object.create(null);
    Object.keys(score).forEach(function (tag) {
      var kind = kindOf(tag);
      (by[kind] = by[kind] || []).push({ tag: tag, score: score[tag] });
    });
    Object.keys(by).forEach(function (kind) {
      by[kind].sort(function (a, b) {
        return b.score - a.score;
      });
    });
    return by;
  }

  /* カート明細のタグ用 div は c_reco セクションごとに出る（Liquid は各セクションが
     独立スコープで「既に出したか」を判定できないため。詳細は
     sections/c_reco.liquid のコメント）。cart.json のように枠が2本あるページでは
     同じ明細が2組 DOM に載るので、読む側を「最初の枠の配下」1組に固定する。
     こうしないとタグの重み付けが枠の本数ぶん倍になり、report() の cartItems も
     実際の明細数の倍を返す。カートの中身はページ全体で同じものなので、
     どの枠の配下を読んでも値は同じ。 */
  function cartTagScope() {
    var first = document.querySelector('[data-reco] [data-reco-cart-tags]');
    // closest() が無い環境（極端に古い WebKit）では枠を特定できないので、
    // 1組も読まない＝カート由来の候補を積まない側に倒す。
    if (!first || typeof first.closest !== 'function') return null;
    return first.closest('[data-reco]');
  }

  function cartTagNodes() {
    var scope = cartTagScope();
    if (!scope) return [];
    return Array.prototype.slice.call(scope.querySelectorAll('[data-reco-cart-tags]'));
  }

  /* カートに入っている商品のタグ。c_reco.liquid が cart.items から出している。
     localStorage を読まないので Customer Privacy API の判断に左右されない。
     閲覧履歴が無い人・同意がまだ取れていない人にも「根拠のある」推薦を出す土台。
     減衰は掛けない。いまカートに入っている＝いまの関心なので、古さが無い。 */
  function cartRankedTags() {
    var score = Object.create(null);
    cartTagNodes().forEach(function (el) {
      (el.getAttribute('data-reco-cart-tags') || '').split(',').forEach(function (raw) {
        var tag = normalizeTag(raw);
        var kind = kindOf(tag);
        if (!kind) return;
        score[tag] = (score[tag] || 0) + WEIGHTS[kind];
      });
    });
    return groupByKind(score);
  }

  /* ---------- 取得先を組み立てる ---------- */

  function base(root) {
    return String(root || '/').replace(/\/$/, '');
  }

  /* タグは URL パスに入るのでエスケープする。
     availability フィルタは、c_reco-items の limit が available 判定より先に
     効くことへの備え。2026-09-20 時点ではストア側で未有効化のため無視されるが、
     同日時点で公開商品 395 件すべてが在庫ありなので実害はない。 */
  function tagPath(root, tags) {
    var path = tags
      .map(function (t) {
        return encodeURIComponent(t);
      })
      .join('+');
    return base(root) + '/collections/all/' + path + '?filter.v.availability=1';
  }

  function collectionPath(root, handle) {
    return base(root) + '/collections/' + encodeURIComponent(handle) + '?filter.v.availability=1';
  }

  /* 返り値の each は { url, onTopic } 。onTopic=false は「見出しと中身が
     ずれる可能性のある一般フォールバック」を意味する。 */
  /* カードが指定のタグを持つか。c_reco-items.liquid が data-tags を
     downcase して出している。属性が無い（古いキャッシュ等）なら false を返し、
     落とさない側に倒す ── 見せすぎより、消しすぎのほうが戻しにくいため。 */
  function cellHasTag(cell, tag) {
    var raw = cell.getAttribute('data-tags');
    if (!raw || !tag) return false;
    var list = raw.split(',');
    for (var i = 0; i < list.length; i++) {
      if (normalizeTag(list[i]) === tag) return true;
    }
    return false;
  }

  /* カートに入っている作り手のタグ全員分（重さは問わない）。 */
  function cartArtisanSet() {
    var set = Object.create(null);
    (cartRankedTags().artisan || []).forEach(function (t) {
      set[t.tag] = true;
    });
    return set;
  }

  /* カードの作り手タグ（artisan-N）。無ければ空文字。 */
  function cellArtisan(cell) {
    var raw = cell.getAttribute('data-tags') || '';
    var list = raw.split(',');
    for (var i = 0; i < list.length; i++) {
      var t = normalizeTag(list[i]);
      if (kindOf(t) === 'artisan') return t;
    }
    return '';
  }

  /* カートページのおすすめ枠の並べ直し（CART_CROSS_ARTISAN_BONUS のコメント参照）。
     一般フォールバック（onTopic=false）から来たカードは、作り手にかかわらず根拠のあるカードより前に出さない。
     Array.prototype.sort は古いエンジンで安定とは限らないので、元の順番を同点の決め手に入れる。 */
  function boostCrossArtisan(cells, inCart, pickedFrom) {
    return cells
      .map(function (cell, i) {
        var from = pickedFrom[cell.getAttribute('data-pid')] || {};
        var a = cellArtisan(cell);
        var bonus = from.onTopic && a && !inCart[a] ? CART_CROSS_ARTISAN_BONUS : 0;
        return { cell: cell, score: (from.onTopic ? 10 : 0) + bonus, i: i };
      })
      .sort(function (x, y) {
        return y.score - x.score || x.i - y.i;
      })
      .map(function (x) {
        return x.cell;
      });
  }

  /* カートで最も重いタグ。「作り手だけ／作り手を除く」の対象になる1人。
     カートが空（商品ページなど）なら空文字を返す。 */
  function cartArtisanTag() {
    var top = (cartRankedTags().artisan || [])[0];
    return top ? top.tag : '';
  }

  /* 「作り手だけ（only）／作り手を除く（exclude）」が対象にする1人を、
     ここ1か所で決める。カートの作り手を優先し、カートが空なら
     閲覧履歴の作り手にフォールバックする。

     ★only と exclude が必ず同じ値を見るための関数。片方だけが
       フォールバックすると、空カートで /cart を開いたときに
       only は履歴の作り手を引くのに exclude の除外が空になり、
       同じ作り手が両方の枠に並ぶ（2026-10-13 修正）。
       cart.json のセクションは空カートでも描画されるので、この状態は到達しうる。
       どちらかを触るときは必ず両方を見ること。

     返り値の source は「どちらを根拠に選んだか」。only 枠の小見出しの
     出し分け（カート用 / 履歴用）に使う。 */
  function targetArtisanTag() {
    var cart = cartArtisanTag();
    if (cart) return { tag: cart, source: 'cart' };
    var top = (rankedTags().artisan || [])[0];
    return { tag: top ? top.tag : '', source: 'history' };
  }

  function candidates(mode, root, scope, cartContext) {
    var out = [];

    function push(url, source) {
      out.push({ url: url, onTopic: true, source: source || 'history' });
    }

    /* scope === 'exclude' — 「この作り手以外」を見せる枠。
       対象の作り手（targetArtisanTag）を種にした経路は積まない。ただしテーマや
       器種の経路からは同じ作り手の別の商品が返ってくるので、URL を外すだけでは
       足りない。返ってきたカードは fill() 側で data-tags を見て落とす。

       ★種に対象の作り手が含まれる経路を積まないのは、積んでも fill() の
         cellHasTag で全セル落ちるだけで、Section Rendering の往復と
         FILL_BUDGET_MS を無駄に食うため。カートページでは「カートに入れた商品＝
         直前に見た商品」になりやすく、履歴の作り手とカートの作り手が
         一致する確率が高い（2026-10-13 修正）。履歴の作り手が別人なら
         従来どおり積まれる。 */
    var dropTag = scope === 'exclude' ? targetArtisanTag().tag : '';

    /* カートページのおすすめ枠では、カートにある作り手を種にした経路を後回しにする。
       先頭のままだと、作品の多い作り手（実測: 古谷製陶所）だけで集める上限が埋まり、
       boostCrossArtisan で前に出す「カートに無い作り手」の候補が 1 枚も集まらない
       （2026-11-02 本番検証: 8 枠すべてがカートの作り手）。経路は消さずに末尾へ回すので、
       ほかの経路で足りないときの埋めには従来どおり使う。 */
    var cartSet = cartContext ? cartArtisanSet() : null;
    var deferred = [];

    function pushTags(tags, source) {
      if (dropTag && tags.indexOf(dropTag) >= 0) return;
      if (cartSet && tags.some(function (t) { return cartSet[t]; })) {
        deferred.push({ url: tagPath(root, tags), source: source });
        return;
      }
      push(tagPath(root, tags), source);
    }

    /* scope === 'only' — 「同じ作り手の器」専用の枠。
       作り手の軸だけを引く。テーマや器種に広げると、見出しの「同じ作り手」が
       嘘になる。対象は targetArtisanTag()（カートの作り手 → 無ければ履歴の作り手）。
       一般フォールバックも積まない（別の作り手が混ざるため）。

       ★ここで早期 return するため、「出すもの」(mode) の設定は使われない。
         この分岐に入った時点で引くのは作り手の軸だけに固定される。
         セクション設定の info にも同じことを書いてある。 */
    if (scope === 'only') {
      var only = targetArtisanTag();
      if (only.tag) push(tagPath(root, [only.tag]), only.source);
      return out;
    }

    /* 閲覧履歴のタグスコアは only 枠では使わないので、早期 return の後で読む
       （only 枠で localStorage を無駄に読まないため）。 */
    var by = rankedTags();
    var artisan = (by.artisan || [])[0];
    var theme = (by.theme || [])[0];
    var category = (by.category || [])[0];

    if (mode === 'recent') {
      var handles = read()
        .slice(0, RECENT_LOOKUP)
        .map(function (v) {
          return 'handle:' + v.handle;
        });
      if (handles.length) {
        // handle: はストアフロント検索の公式な検索可能プロパティ一覧に無いが、
        // 2026-09-21 の実測では field 指定として機能している
        // （handle:product-406 → 1件 / 素の product-406 → 0件）。
        // 仮に将来効かなくなっても 0 件になるだけで、min 割れにより
        // セクションごと消えるため表示が壊れることはない。
        push(
          base(root) +
            '/search?type=product&options[unavailable_products]=hide&q=' +
            encodeURIComponent(handles.join(' OR '))
        );
      }
      // 閲覧履歴に一般フォールバックは積まない。
      // 「Recently Viewed」の下に一度も見ていない商品が並ぶのを避ける。
      return out;
    }

    if (mode === 'artisan') {
      if (artisan) pushTags([artisan.tag]);
    } else if (mode === 'complement') {
      if (artisan && category) pushTags([artisan.tag, category.tag]);
      if (artisan) pushTags([artisan.tag]);
      if (theme) pushTags([theme.tag]);
    } else {
      if (artisan && theme) pushTags([artisan.tag, theme.tag]);
      if (artisan) pushTags([artisan.tag]);
      if (theme) pushTags([theme.tag]);
      if (category) pushTags([category.tag]);
    }

    /* カートの中身からの候補。履歴があるときは後ろに積むだけなので、
       これまでの並びは変わらない。履歴が無い人・同意が取れていない人にとっては、
       これが唯一の「根拠のある」候補になる。カートの商品自体は
       data-reco-exclude-id で除外されるので、カートの中身は出てこない。 */
    var cart = cartRankedTags();
    var cartArtisan = (cart.artisan || [])[0];
    var cartTheme = (cart.theme || [])[0];
    var cartCategory = (cart.category || [])[0];
    /* 下の cartArtisan を種にした2本は、exclude 枠では pushTags が積まない
       （カートが非空なら dropTag ＝ cartArtisan.tag なので必ず一致する）。 */
    if (cartArtisan && cartTheme) pushTags([cartArtisan.tag, cartTheme.tag], 'cart');
    if (cartArtisan) pushTags([cartArtisan.tag], 'cart');
    if (cartTheme) pushTags([cartTheme.tag], 'cart');
    if (cartCategory) pushTags([cartCategory.tag], 'cart');
    /* カートページのおすすめ枠だけ、産地の経路も足す。産地は作り手をまたぎやすい軸（実測 lift 2.37）で、
       カートの作り手と別の人の器を拾う。末尾なので、これまでの候補の並びは変わらない。 */
    var cartOrigin = (cart.origin || [])[0];
    if (cartContext && cartOrigin) pushTags([cartOrigin.tag], 'cart');
    deferred.forEach(function (d) {
      push(d.url, d.source);
    });

    /* 根拠のある候補が1本も作れなかったときは、一般のおすすめに落とさない。
       「一度も見ていない商品」を根拠なく並べないため（2026-09-27 オーナー判断）。
       候補 0 本なので fill() の min 判定でセクションごと消える。
       カートページでは、カートの商品がタグを持つ限りここには来ない。

       ★これは recent だけでなく artisan / complement / session にも効く。
         初回訪問で、かつカートの商品が4接頭辞のタグを1つも持たない場合は、
         session の You Might Also Like も枠ごと消える（以前はフォールバックで
         埋まっていた）。全モードで「根拠が無いなら出さない」に揃える判断。
         表示率を優先してモード別に戻す場合はオーナー確認が必要。 */
    if (!out.length) return out;

    // 候補が尽きたときの受け皿。ここに落ちた場合は見出しの補足文を消す。
    FALLBACK_HANDLES.forEach(function (h) {
      out.push({ url: collectionPath(root, h), onTopic: false, source: 'fallback' });
    });

    return out;
  }

  function withSection(url) {
    return url + (url.indexOf('?') < 0 ? '?' : '&') + 'section_id=c_reco-items';
  }

  /* ---------- 取得と描画 ---------- */

  var fetchCache = Object.create(null);

  /* 2本のレールは同じフォールバック URL を辿るので、同一 URL の取得は共有する。
     取り出すたびに複製しないと、片方の DOM に挿した要素がもう片方から消える。 */
  function fetchCells(url) {
    if (!fetchCache[url]) fetchCache[url] = rawFetchCells(url);
    return fetchCache[url].then(function (cells) {
      return cells.map(function (c) {
        return c.cloneNode(true);
      });
    });
  }

  var FETCH_TIMEOUT_MS = 5000;

  /* 1本のレールが候補 URL を辿るのに使える全体の持ち時間。
     候補は最大11本（履歴1 + タグ4 + カート4〜5（産地はカートページだけ） + フォールバック2 の組み合わせ）で、
     step() は直列なので URL 単位の FETCH_TIMEOUT_MS だけでは
     最悪で 5秒 × 本数 まで伸びる（レールが2本あればさらに直列で倍）。
     画面外からの遅延取得なので体感は小さいが、最悪値を固定しておく。
     途中で切れた場合は、そこまでに集まった分で min 判定に進む。 */
  var FILL_BUDGET_MS = 8000;

  function rawFetchCells(url) {
    var opts = { credentials: 'same-origin' };
    var timer = null;
    if ('AbortController' in window) {
      var ac = new AbortController();
      opts.signal = ac.signal;
      timer = setTimeout(function () {
        ac.abort();
      }, FETCH_TIMEOUT_MS);
    }
    return fetch(withSection(url), opts)
      .then(function (res) {
        return res.ok ? res.text() : '';
      })
      .then(function (html) {
        if (!html) return [];
        // template の中身は現在のドキュメントに属さないので、
        // 画像の読み込みもイベントハンドラも走らない。
        var tpl = document.createElement('template');
        tpl.innerHTML = html;
        return Array.prototype.slice.call(tpl.content.querySelectorAll('[data-reco-cell]'));
      })
      .catch(function () {
        return [];
      })
      .then(function (cells) {
        if (timer) clearTimeout(timer);
        return cells;
      });
  }

  /* ページ上の「出してはいけない」ID（カート内・表示中の商品）。
     これは fill() 中に増えないのでスナップショットでよい。 */
  function pageExcludedIds() {
    var ids = Object.create(null);
    document.querySelectorAll('[data-reco-exclude-id]').forEach(function (el) {
      ids[el.getAttribute('data-reco-exclude-id')] = true;
    });
    return ids;
  }

  /* takenIds はレール間で共有する生きた台帳。コピーを取ると、同じ tick で
     走るもう1本のレールに自分の取得分が伝わらず重複表示になる。 */
  function isTaken(pid, pageIds) {
    return !!takenIds[pid] || !!pageIds[pid];
  }

  /* 検索結果はこちらの並びを保たないので、閲覧の新しい順に並べ直す。
     あわせて履歴に無いものは落とす。handle: は公式な検索可能プロパティ
     一覧に無い書き方なので、将来効かなくなったときに「見ていない商品が
     Recently Viewed に並ぶ」ことを、挙動ではなく構造で防ぐ。 */
  function orderForRecent(cells) {
    var rank = Object.create(null);
    read().forEach(function (v, i) {
      rank[v.handle] = i;
    });
    return cells
      .filter(function (cell) {
        return rank[cell.getAttribute('data-handle')] !== undefined;
      })
      .sort(function (a, b) {
        return rank[a.getAttribute('data-handle')] - rank[b.getAttribute('data-handle')];
      });
  }

  /* 枠を出した／消した理由を外に出す。「なぜ出ていないか」を推測で語らないため。
     Clarity はカスタムタグとしてセッションリプレイで絞り込める。
     Shopify.analytics.publish は Web Pixel 側で GA4 などに転送できる。
     いずれも落ちても表示は壊さない。 */
  function report(status, reason, section, count) {
    /* テーマエディタのプレビューは計測に混ぜない。drop() が designMode では
       必ず 'dropped' を通すため、入れておくとマーチャントの設定操作が
       そのまま本番の指標に乗ってしまう。 */
    try {
      if (window.Shopify && window.Shopify.designMode) return;
    } catch (e) {
      /* noop */
    }

    var detail;
    var mode;
    try {
      mode = section.getAttribute('data-reco-mode') || '';
      detail = {
        status: status,
        reason: reason,
        mode: mode,
        consent: consentDecision,
        allowed: allowedNow(),
        history: read().length,
        cartItems: cartTagNodes().length,
        count: count || 0
      };
    } catch (e) {
      return;
    }

    /* 外部への送信は、このファイル全体の方針（allowedNow / read と同じ fail-closed）
       に揃える。consentDecision が 'timeout'（同意 API が1.5秒に間に合わなかった）や
       バナー未回答のまま送らない。送る中身は件数と状態文字列だけで個人データは
       含まないが、1ファイル内で方針が揃っていないほうが筋が悪い。
       in-page の CustomEvent は外に出ないので同意に依らず流す。 */
    var mayTransmit = false;
    try {
      mayTransmit = allowedNow();
    } catch (e) {
      mayTransmit = false;
    }

    if (mayTransmit) {
      /* 枠は1ページに複数載るので、どの枠の値かが分かるよう mode を先頭に付ける
         （例: session:shown:cart）。 */
      try {
        if (window.clarity) window.clarity('set', 'nkz_reco', mode + ':' + status + ':' + reason);
      } catch (e) {
        /* noop */
      }
      try {
        if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
          window.Shopify.analytics.publish('nkz_reco', detail);
        }
      } catch (e) {
        /* noop */
      }
    }

    try {
      document.dispatchEvent(new CustomEvent('nkz:reco', { detail: detail }));
    } catch (e) {
      /* noop */
    }
  }

  function drop(section, reason) {
    report('dropped', reason || 'unknown', section, 0);
    // テーマエディタでは消さない。マーチャントが選択・設定できなくなるため。
    if (window.Shopify && window.Shopify.designMode) {
      var row = section.querySelector('[data-reco-row]');
      if (row) row.setAttribute('aria-busy', 'false');
      section.hidden = false;
      section.setAttribute('data-reco-empty', '1');
      return;
    }
    var anchor = section.previousElementSibling;
    if (anchor && anchor.hasAttribute('data-reco-anchor')) anchor.remove();
    section.remove();
  }

  function fill(section) {
    var mode = section.getAttribute('data-reco-mode') || 'recent';
    var root = section.getAttribute('data-reco-root') || '/';
    var min = parseInt(section.getAttribute('data-reco-min'), 10) || 2;
    var max = parseInt(section.getAttribute('data-reco-max'), 10) || 8;
    var scope = section.getAttribute('data-reco-artisan-scope') || 'any';
    var row = section.querySelector('[data-reco-row]');
    if (!row) return Promise.resolve();

    /* 「作り手を除く」枠では、どの経路から返ってきたカードでも
       その作り手のものは落とす。URL を外すだけでは、テーマや器種の経路から
       同じ作り手が入ってくる（実測: theme-1 の24点のうち12点が artisan-82）。

       ★対象は only 枠と同じ targetArtisanTag()。candidates() の dropTag と
         必ず同じ値でなければならない（片方だけがフォールバックすると
         空カートで同じ作り手が両方の枠に並ぶ）。 */
    var excludeArtisan = scope === 'exclude' ? targetArtisanTag().tag : '';

    /* カートページのおすすめ枠だけ、カートに無い作り手を前に出す。
       data-reco-context は c_reco.liquid がカートのテンプレートでだけ 'cart' にする
       （カートの明細タグは全ページに出るので、カートが空でないかだけでは判定しない）。 */
    var cartInSet = null;
    if (section.getAttribute('data-reco-context') === 'cart' && scope !== 'only' && mode !== 'recent') {
      cartInSet = cartArtisanSet();
      if (!Object.keys(cartInSet).length) cartInSet = null;
    }

    var urls = candidates(mode, root, scope, !!cartInSet);
    var picked = [];
    var pageIds = pageExcludedIds();
    var localIds = Object.create(null);
    var usedFallbackOnly = true;
    var usedSources = Object.create(null);
    // どの候補 URL から来たカードか。根拠（小見出し・計測）は「実際に出した分」だけで決める
    // （カートページでは max より多く集めてから絞るため、集めた全量で決めるとずれる）。
    var pickedFrom = Object.create(null);
    // 走り出したあとに resetShared() が入ったら、この fill の結果は捨てる
    var myGen = generation;

    // recent は「新しい順」に並べ替えてから切るので、上限まで取り切ってから絞る
    var collectMax = mode === 'recent' ? RECENT_LOOKUP : cartInSet ? max * CART_COLLECT_FACTOR : max;

    // 候補を辿る全体の期限。URL 単位の打ち切りだけだと最悪値が本数ぶん伸びる。
    var deadline = Date.now() + FILL_BUDGET_MS;

    function step(i) {
      if (i >= urls.length || picked.length >= collectMax) return Promise.resolve();
      // 1本目は必ず試す（i > 0）。全体の期限を過ぎたらそこで打ち切る。
      if (i > 0 && Date.now() > deadline) return Promise.resolve();
      return fetchCells(urls[i].url).then(function (cells) {
        cells.forEach(function (cell) {
          if (picked.length >= collectMax) return;
          var pid = cell.getAttribute('data-pid');
          if (!pid || isTaken(pid, pageIds) || localIds[pid]) return;
          if (excludeArtisan && cellHasTag(cell, excludeArtisan)) return;
          localIds[pid] = true;
          picked.push(cell);
          pickedFrom[pid] = urls[i];
        });
        return step(i + 1);
      });
    }

    return step(0).then(function () {
      if (myGen !== generation) return;

      // 絞り込みは min 判定より先。履歴に無いものを落とした結果
      // min を割ることがあるため。
      if (mode === 'recent') picked = orderForRecent(picked);
      if (cartInSet) picked = boostCrossArtisan(picked, cartInSet, pickedFrom);

      if (picked.length < min) {
        drop(section, urls.length ? 'too-few' : 'no-candidates');
        return;
      }
      picked = picked.slice(0, max);
      picked.forEach(function (cell) {
        var from = pickedFrom[cell.getAttribute('data-pid')] || {};
        usedSources[from.source || 'history'] = true;
        if (from.onTopic) usedFallbackOnly = false;
      });

      // 台帳への登録は「表示が確定した分だけ」。取得しただけの分は登録しない。
      // 確保と解放を対にしないので、返し忘れも他レールの分を消す事故も起きない。
      picked.forEach(function (cell) {
        takenIds[cell.getAttribute('data-pid')] = true;
      });

      /* 補足文は「何を根拠に選んだか」を名乗る文なので、根拠と揃える。
           一般フォールバックだけ  → 根拠が無いので消す
           カートの中身だけ        → カート用の文に差し替える（未設定なら消す）
           閲覧履歴が混ざっている  → そのまま */
      var sub = section.querySelector('[data-reco-sub]');
      if (sub) {
        if (usedFallbackOnly) {
          sub.remove();
        } else if (usedSources.cart && !usedSources.history) {
          var cartSub = section.getAttribute('data-reco-sub-cart') || '';
          if (cartSub) {
            sub.textContent = cartSub;
          } else {
            sub.remove();
          }
        }
        /* 器だけ出して中身が入らなかった場合（汎用の小見出しを空欄にして
           カート用だけ設定し、カート由来では無かったとき）は消す。
           Dawn の `p:empty { display: none }` でも描画されないが、
           Dawn 側のセレクタ一覧に依存しないようここでも落とす。 */
        if (sub.parentNode && !sub.textContent.trim()) sub.remove();
      }

      row.innerHTML = '';
      picked.forEach(function (cell) {
        row.appendChild(cell);
      });
      row.setAttribute('aria-busy', 'false');
      section.hidden = false;
      section.setAttribute('data-reco-count', String(picked.length));
      section.setAttribute('data-reco-source', usedFallbackOnly ? 'fallback' : usedSources.history ? 'history' : 'cart');
      report(
        'shown',
        usedFallbackOnly ? 'fallback' : usedSources.history ? 'history' : 'cart',
        section,
        picked.length
      );
    });
  }

  /* ---------- 起動 ---------- */

  var observer = null;
  var generation = 0;
  /* レールは DOM 順に1本ずつ確定させる。並列に走らせると、先に fetch が
     返ったほうが閲覧履歴の商品を確保し、Recently Viewed が min 割れで
     消えて You Might Also Like にその商品が並ぶ、という取り違えが起きる。
     高々2本で、どちらも画面外からの遅延取得なので直列でも体感差は無い。 */
  var chain = Promise.resolve();

  /* 世代は「並べた時点」で確保する。fill 開始時に取ると、待機中に
     resetShared() が入った fill が新世代を名乗って復活し、
     旧チェーンと新チェーンが並走してしまう。 */
  function enqueue(section) {
    var gen = generation;
    chain = chain
      .then(function () {
        if (gen !== generation) return;
        return fill(section);
      })
      // ここで握らないと、一度の reject で以降すべてのレールが永久に
      // 埋まらなくなる（chain はページの寿命いっぱい生きるため）。
      .catch(function () {});
    return chain;
  }

  /* テーマエディタの再描画（shopify:section:load）では、共有台帳と取得キャッシュを
     捨てる。残したままだと再描画されたレールだけ中身が入れ替わる／空になる。 */
  function resetShared() {
    generation += 1;
    chain = Promise.resolve();
    takenIds = Object.create(null);
    fetchCache = Object.create(null);
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    document.querySelectorAll('[data-reco][data-reco-ready]').forEach(function (s) {
      s.removeAttribute('data-reco-ready');
    });
  }

  /* いま見ている商品を記録する。同意前は何もせず、フラグも立てない。
     同意が後から取れたときに visitorConsentCollected から呼び直される。 */
  function recordSeed() {
    var seed = document.querySelector('[data-reco-track]');
    if (!seed || seed.hasAttribute('data-reco-recorded') || !allowedNow()) return;
    seed.setAttribute('data-reco-recorded', '1');
    record({
      handle: seed.getAttribute('data-reco-handle'),
      tags: (seed.getAttribute('data-reco-tags') || '').split(',').filter(Boolean)
    });
  }

  function boot() {
    // 商品ページなら、まず今見ている商品を記録する。
    recordSeed();

    var sections = document.querySelectorAll('[data-reco]:not([data-reco-ready])');
    if (!sections.length) return;

    /* section は hidden（display:none）でレイアウトボックスを持たないため、
       section 自体を監視すると IntersectionObserver は発火しない。
       常に描画される直前の 1px アンカーを監視する。 */
    function anchorFor(section) {
      var prev = section.previousElementSibling;
      return prev && prev.hasAttribute('data-reco-anchor') ? prev : null;
    }

    var io = observer =
      'IntersectionObserver' in window
        ? new IntersectionObserver(
            function (entries, obs) {
              entries.forEach(function (e) {
                if (!e.isIntersecting) return;
                obs.unobserve(e.target);
                var section = e.target.nextElementSibling;
                if (!section || !section.hasAttribute('data-reco')) return;
                section.setAttribute('data-reco-ready', '1');
                enqueue(section);
              });
            },
            { rootMargin: '400px 0px' }
          )
        : null;

    sections.forEach(function (s) {
      var anchor = io ? anchorFor(s) : null;
      if (anchor) {
        io.observe(anchor);
      } else {
        // アンカーが無い／IO 非対応。遅延取得は諦めて確実に埋める。
        s.setAttribute('data-reco-ready', '1');
        enqueue(s);
      }
    });
  }

  function start() {
    withConsentApi(boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', function () {
    resetShared();
    boot();
  });
})();
